import React from 'react';
import Popper from '@di-shared/features/common/Popper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function VehicleSestTooltipKr() {
  const {t} = useInferableTranslation();

  return (
    <Popper
      placement="bottom"
      className="tooltip"
      marginLeft={3}
      tooltip={
        <div
          id="tooltipBox01"
          role="tooltip"
          tabIndex={0}
        >
          <strong className="tooltip_heading">{t('T10106')}</strong>
          <p
            className="tooltip_text"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T10107')}
          </p>
          <ul className="tooltip_list">
            <li className="tooltip_item">{t('T10109')}</li>
            <li className="tooltip_item">{t('T10157')}</li>
            <li
              className="tooltip_item"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T10108')}
            </li>
            <li
              className="tooltip_item"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T30628')}
            </li>
            <li
              className="tooltip_item"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T30639')}
            </li>
          </ul>
        </div>
      }
    >
      <div className="tooltip_area tooltip_area_single">
        <button
          aria-describedby="tooltipBox01"
          className="btn_tooltip"
          aria-controls="tooltipStatement01"
          aria-expanded="false"
          type="button"
        >
          <span
            className="ic ic_information_16px"
            aria-hidden="true"
          />
          <span className="blind">{t('T10044')}</span>
        </button>
      </div>
    </Popper>
  );
}

export default VehicleSestTooltipKr;
